export default "<ejs-richtexteditor\n#toolsRTE\n  [toolbarSettings]=\"toolbarSettings\"\n  [(ngModel)]=\"inputValue\"\n></ejs-richtexteditor>\n"